import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_templatesplugin3cf72d88_977104ec from 'nuxt_plugin_templatesplugin3cf72d88_977104ec' // Source: ./templates.plugin.3cf72d88.js (mode: 'client')
import nuxt_plugin_storage_81fdebf0 from 'nuxt_plugin_storage_81fdebf0' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_gtm_04e5d97a from 'nuxt_plugin_gtm_04e5d97a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_32168ad5 from 'nuxt_plugin_cookieuniversalnuxt_32168ad5' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_2faae52d from 'nuxt_plugin_axios_2faae52d' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_App_5e45aacb from 'nuxt_plugin_App_5e45aacb' // Source: ../client/plugins/App (mode: 'all')
import nuxt_plugin_EventBus_0784ff1c from 'nuxt_plugin_EventBus_0784ff1c' // Source: ../client/plugins/EventBus (mode: 'all')
import nuxt_plugin_EpecaApi_6d081cd0 from 'nuxt_plugin_EpecaApi_6d081cd0' // Source: ../client/plugins/EpecaApi (mode: 'all')
import nuxt_plugin_Filters_17186fa5 from 'nuxt_plugin_Filters_17186fa5' // Source: ../client/plugins/Filters (mode: 'all')
import nuxt_plugin_GtmHelpers_47dd055b from 'nuxt_plugin_GtmHelpers_47dd055b' // Source: ../client/plugins/GtmHelpers (mode: 'all')
import nuxt_plugin_Helpers_7a0fb22f from 'nuxt_plugin_Helpers_7a0fb22f' // Source: ../client/plugins/Helpers (mode: 'all')
import nuxt_plugin_VueMq_369f9018 from 'nuxt_plugin_VueMq_369f9018' // Source: ../client/plugins/VueMq (mode: 'all')
import nuxt_plugin_VueMoment_21420450 from 'nuxt_plugin_VueMoment_21420450' // Source: ../client/plugins/VueMoment (mode: 'all')
import nuxt_plugin_VueAxios_93c9ffb4 from 'nuxt_plugin_VueAxios_93c9ffb4' // Source: ../client/plugins/VueAxios (mode: 'all')
import nuxt_plugin_epa_5e4631e0 from 'nuxt_plugin_epa_5e4631e0' // Source: ../client/plugins/epa (mode: 'all')
import nuxt_plugin_globalComponents_97da3ae2 from 'nuxt_plugin_globalComponents_97da3ae2' // Source: ../client/plugins/globalComponents (mode: 'all')
import nuxt_plugin_Vuelidate_55cf8cdb from 'nuxt_plugin_Vuelidate_55cf8cdb' // Source: ../client/plugins/Vuelidate (mode: 'client')
import nuxt_plugin_card_6a7eeb86 from 'nuxt_plugin_card_6a7eeb86' // Source: ../client/plugins/card (mode: 'client')
import nuxt_plugin_VueGoogleMaps_68c4eec0 from 'nuxt_plugin_VueGoogleMaps_68c4eec0' // Source: ../client/plugins/VueGoogleMaps (mode: 'client')
import nuxt_plugin_VCalendar_380812fe from 'nuxt_plugin_VCalendar_380812fe' // Source: ../client/plugins/VCalendar (mode: 'client')
import nuxt_plugin_carousel_1978b254 from 'nuxt_plugin_carousel_1978b254' // Source: ../client/plugins/carousel (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"pt-br"},"title":"Loja virtual","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google-site-verification","content":undefined}],"bodyAttrs":{"class":"ktm"},"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fcustom\u002Floja\u002Fassets\u002Fmedia\u002Ffavicon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans:300,300i,400,400i,600,600i,700,700i"},{"rel":"stylesheet","href":"\u002Fcustom\u002Fepeca\u002Fassets\u002Fext\u002Ffontawesome-free-5.15.1-web\u002Fcss\u002Fall.min.css"}],"__dangerouslyDisableSanitizers":["script"],"script":[{"hid":"search-insights1","src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fsearch-insights@2.2.1","defer":true},{"hid":"search-insights2","innerHTML":"\n\t\t\t!function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){\n\t\t\t\t(e[s].queue=e[s].queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],\n\t\t\t\ti.async=1,i.src=n,c.parentNode.insertBefore(i,c)\n\t\t\t\t}(window,document,\"script\",\"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fsearch-insights@2.2.1\",\"aa\");\n\t\t\t","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"ms-clarity","innerHTML":"(function(c,l,a,r,i,t,y){\n\t\t\t\t\tc[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n\t\t\t\t\tt=l.createElement(r);t.async=1;t.src=\"https:\u002F\u002Fwww.clarity.ms\u002Ftag\u002F\"+i;\n\t\t\t\t\ty=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n\t\t\t\t})(window, document, \"clarity\", \"script\", \"eq15if0dny\");","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T6FLB3TW')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T6FLB3TW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_templatesplugin3cf72d88_977104ec === 'function') {
    await nuxt_plugin_templatesplugin3cf72d88_977104ec(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_81fdebf0 === 'function') {
    await nuxt_plugin_storage_81fdebf0(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_04e5d97a === 'function') {
    await nuxt_plugin_gtm_04e5d97a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_32168ad5 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_32168ad5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2faae52d === 'function') {
    await nuxt_plugin_axios_2faae52d(app.context, inject)
  }

  if (typeof nuxt_plugin_App_5e45aacb === 'function') {
    await nuxt_plugin_App_5e45aacb(app.context, inject)
  }

  if (typeof nuxt_plugin_EventBus_0784ff1c === 'function') {
    await nuxt_plugin_EventBus_0784ff1c(app.context, inject)
  }

  if (typeof nuxt_plugin_EpecaApi_6d081cd0 === 'function') {
    await nuxt_plugin_EpecaApi_6d081cd0(app.context, inject)
  }

  if (typeof nuxt_plugin_Filters_17186fa5 === 'function') {
    await nuxt_plugin_Filters_17186fa5(app.context, inject)
  }

  if (typeof nuxt_plugin_GtmHelpers_47dd055b === 'function') {
    await nuxt_plugin_GtmHelpers_47dd055b(app.context, inject)
  }

  if (typeof nuxt_plugin_Helpers_7a0fb22f === 'function') {
    await nuxt_plugin_Helpers_7a0fb22f(app.context, inject)
  }

  if (typeof nuxt_plugin_VueMq_369f9018 === 'function') {
    await nuxt_plugin_VueMq_369f9018(app.context, inject)
  }

  if (typeof nuxt_plugin_VueMoment_21420450 === 'function') {
    await nuxt_plugin_VueMoment_21420450(app.context, inject)
  }

  if (typeof nuxt_plugin_VueAxios_93c9ffb4 === 'function') {
    await nuxt_plugin_VueAxios_93c9ffb4(app.context, inject)
  }

  if (typeof nuxt_plugin_epa_5e4631e0 === 'function') {
    await nuxt_plugin_epa_5e4631e0(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponents_97da3ae2 === 'function') {
    await nuxt_plugin_globalComponents_97da3ae2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_Vuelidate_55cf8cdb === 'function') {
    await nuxt_plugin_Vuelidate_55cf8cdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_card_6a7eeb86 === 'function') {
    await nuxt_plugin_card_6a7eeb86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueGoogleMaps_68c4eec0 === 'function') {
    await nuxt_plugin_VueGoogleMaps_68c4eec0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VCalendar_380812fe === 'function') {
    await nuxt_plugin_VCalendar_380812fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_carousel_1978b254 === 'function') {
    await nuxt_plugin_carousel_1978b254(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
